import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_334 implements Validator {

    public static id = 'CTRL_334';
    private message = 'error.ctr_334';


    public LOG: LogService = new LogService(CTRL_334);
    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_334.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const valeurNameWithStepId = map.get(ctrl.value.rgCtrls.valeur);
                const valeurCtrl = form.controls[valeurNameWithStepId];
                const monnaieNameWithStepId = map.get(ctrl.value.rgCtrls.monnaie);
                const monnaieCtrl = form.controls[monnaieNameWithStepId];
                const pourcentageNameWithStepId = map.get(ctrl.value.rgCtrls.pourcentage);
                const pourcentageCtrl = form.controls[pourcentageNameWithStepId];
                const inconnueNameWithStepId = map.get(ctrl.value.rgCtrls.inconnue);
                const inconnueCtrl = form.controls[inconnueNameWithStepId];

                let filled = 0;
                if (!this.isEmpty(valeurCtrl, false) || !this.isEmpty(monnaieCtrl, false)) filled++;
                if (!this.isEmpty(pourcentageCtrl, false)) filled++;
                if (!this.isEmpty(inconnueCtrl, true)) filled++;

                if (filled != 1) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else if(filled === 1 && ((!this.isEmpty(valeurCtrl, false) && this.isEmpty(monnaieCtrl, false)) || (this.isEmpty(valeurCtrl, false) && !this.isEmpty(monnaieCtrl, false)))) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }

    public isEmpty(ctrl, isBoolean) {
        return ctrl == undefined || ctrl == null || ctrl.value == undefined || ctrl.value == null || ctrl.value == '0' || (!isBoolean && ctrl.value == '');
    }
}